import {Order, OrderField} from "../../../../app/api/model/order";
import React from "react";
import {getOrderAdminUserValidationSchema} from "../validation";
import {UseModal} from "../../../../hooks/useModal";
import {InputFieldType} from "../../../../components/input/factory/types";
import UpdateDialog from "../../../../components/Dialog/UpdateDialog";
import {OrderUpdateAdminUserRequest, useOrderUpdateAdminUserMutation} from "../../../../app/api/api";

export interface OrderDetailsAdminUserFormParams {
    order?: Order;
    modal: UseModal;
    onSuccess?: () => void;
}

export default function OrderDetailsAdminUserForm({order, modal, onSuccess}: OrderDetailsAdminUserFormParams) {
    const [updateAdminUser] = useOrderUpdateAdminUserMutation();
    const initialValues = {
        id: order?.id,
        shippingRecipient: order?.shippingRecipient,
        adminUser: order?.adminUser,
        comment: order?.comment,
    };

    return (
        <UpdateDialog
            titleKey={"action_updateAdminUser"}
            validationSchema={getOrderAdminUserValidationSchema}
            inputFields={[
                {
                    translationKey: "id",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "id",
                    required: true,
                    type: InputFieldType.HIDDEN,
                },
                {
                    translationKey: "user_firstName",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "firstName",
                    required: true,
                },
                {
                    translationKey: "user_lastName",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "lastName",
                    required: true,
                },
                {
                    translationKey: "generic_email",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "email",
                    required: true,
                },
                {
                    translationKey: "generic_phone",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "phone",
                    required: true,
                },
                {
                    translationKey: "organizations_adminLanguage",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "language",
                    type: InputFieldType.LANGUAGE,
                    required: true,
                },
                {
                    translationKey: "generic_timeZone",
                    fieldName: OrderField.ADMIN_USER,
                    subFieldName: "timeZone",
                },
            ]}
            onSuccess={onSuccess}
            entity={order}
            initialValues={initialValues}
            modal={modal}
            spacing={5}
            onSubmit={async (payload: Partial<Order>) => {
                const requestData: OrderUpdateAdminUserRequest = {
                    id: payload.id!,
                    adminUser: payload.adminUser!,
                };
                await updateAdminUser(requestData).unwrap();
            }}
        />
    );
}
